export default "__VITE_ASSET__N9bWYK$2__"